import * as React from 'react';
import Box from '@mui/material/Box';
import Avatar from '@mui/material/Avatar';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import GavelIcon from '@mui/icons-material/Gavel';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import StarIcon from '@mui/icons-material/Star';
import ListAltIcon from '@mui/icons-material/ListAlt';
import Logout from '@mui/icons-material/Logout';
import CloseIcon from '@mui/icons-material/Close';
import AssignmentTurnedInIcon from '@mui/icons-material/AssignmentTurnedIn';
import AssignmentLateIcon from '@mui/icons-material/AssignmentLate';
import { useTheme, useMediaQuery } from '@mui/material';

export const MenuElement = () => {
    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);
    
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    
    const handleClose = () => {
        setAnchorEl(null);
    };

    // Стили для полноэкранного меню на мобильных устройствах
    const mobileMenuStyles = {
        '& .MuiPaper-root': {
            width: '100vw',
            height: '100vh',
            maxHeight: '100vh',
            maxWidth: '100vw',
            margin: 0,
            top: '0 !important',
            left: '0 !important',
            right: 0,
            bottom: 0,
            borderRadius: 0,
            backgroundColor: theme.palette.background.paper
        },
        '& .MuiList-root': {
            paddingTop: '20px',
            paddingBottom: '20px',
        },
        '& .MuiMenuItem-root': {
            padding: '16px 24px',
            fontSize: '1.1rem',
        },
        '& .MuiListItemIcon-root': {
            minWidth: '40px',
        },
        '&::before': {
            display: 'none',
        }
    };

    // Стили для десктопного меню
    const desktopMenuStyles = {
        '& .MuiPaper-root': {
            overflow: 'visible',
            filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
            mt: 1.5,
            maxHeight: 'calc(100vh - 100px)',
            overflowY: "auto",
            '& .MuiAvatar-root': {
                width: 32,
                height: 32,
                ml: -0.5,
                mr: 1,
            },
            '&::before': {
                content: '""',
                display: 'block',
                position: 'absolute',
                top: 0,
                right: 14,
                width: 10,
                height: 10,
                bgcolor: 'background.paper',
                transform: 'translateY(-50%) rotate(45deg)',
                zIndex: 0,
            },
        },
    };

    return (
        <React.Fragment>
            <Box sx={{ display: 'flex', alignItems: 'center', textAlign: 'center' }}>
                <Tooltip title="Account settings">
                    <IconButton
                        onClick={handleClick}
                        size="small"
                        sx={{ ml: 2 }}
                        aria-controls={open ? 'account-menu' : undefined}
                        aria-haspopup="true"
                        aria-expanded={open ? 'true' : undefined}
                    >
                        <Avatar sx={{ width: 32, height: 32 }}>M</Avatar>
                    </IconButton>
                </Tooltip>
            </Box>
            <Menu
                anchorEl={anchorEl}
                id="account-menu"
                open={open}
                onClose={handleClose}
                onClick={handleClose}
                slotProps={{
                    paper: isMobile ? {
                        elevation: 0,
                        sx: mobileMenuStyles['& .MuiPaper-root']
                    } : {
                        elevation: 0,
                        sx: desktopMenuStyles['& .MuiPaper-root']
                    },
                }}
                sx={isMobile ? mobileMenuStyles : {}}
                transformOrigin={{ horizontal: 'right', vertical: 'top' }}
                anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
                // Для мобильных: растягиваем меню на весь экран
                {...(isMobile && {
                    anchorOrigin: {
                        vertical: 'bottom',
                        horizontal: 'right',
                    },
                    transformOrigin: {
                        vertical: 'top',
                        horizontal: 'right',
                    },
                })}
            >
                {isMobile && (
                    <Box sx={{ 
                        display: 'flex', 
                        justifyContent: 'space-between', 
                        alignItems: 'center',
                        padding: '16px 24px',
                        borderBottom: `1px solid ${theme.palette.divider}`
                    }}>
                        <Box sx={{ display: 'flex', alignItems: 'center' }}>
                            <Avatar sx={{ width: 40, height: 40, mr: 2 }}>M</Avatar>
                            <Box>
                                <Box sx={{ fontWeight: 'bold' }}>Мой профиль</Box>
                            </Box>
                        </Box>
                        <IconButton 
                            onClick={handleClose}
                            size="small"
                            sx={{ ml: 2 }}
                        >
                            <CloseIcon />
                        </IconButton>
                    </Box>
                )}
                
                {!isMobile && (
                    <MenuItem onClick={handleClose}>
                        <Avatar /> Мой Профиль
                    </MenuItem>
                )}
                
                {!isMobile && <Divider />}
                
                <MenuItem onClick={handleClose}>
                    <ListItemIcon>
                        <GavelIcon fontSize="small" />
                    </ListItemIcon>
                    Активные торги
                </MenuItem>
                <MenuItem onClick={handleClose}>
                    <ListItemIcon>
                        <ListAltIcon fontSize="small" />
                    </ListItemIcon>
                    Завершенные торги
                </MenuItem>
                <MenuItem onClick={handleClose}>
                    <ListItemIcon>
                        <AssignmentTurnedInIcon fontSize="small" />
                    </ListItemIcon>
                    Заказы
                </MenuItem>
                <MenuItem onClick={handleClose}>
                    <ListItemIcon>
                        <AccountBalanceIcon fontSize="small" />
                    </ListItemIcon>
                    Мои подписки
                </MenuItem>
                <MenuItem onClick={handleClose}>
                    <ListItemIcon>
                        <StarIcon fontSize="small" />
                    </ListItemIcon>
                    Избранные лоты
                </MenuItem>
                
                <Divider />
                
                <MenuItem onClick={handleClose}>
                    <ListItemIcon>
                        <AssignmentLateIcon fontSize="small" />
                    </ListItemIcon>
                    Правила
                </MenuItem>
                
                <Divider />
                
                <MenuItem onClick={handleClose}>
                    <ListItemIcon>
                        <Logout fontSize="small" />
                    </ListItemIcon>
                    Выход
                </MenuItem>
                
                {isMobile && <Box sx={{ height: '20px' }} />}
            </Menu>
        </React.Fragment>
    )
}